"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementErrorBoundaryProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var sceneErrorBoundaryProps = {
  sectionWidth: '100%',
  buttonText: 'Reload',
  iconType: 'failure',
  reloadIcon: false,
  reloadButtonPosition: 'center'
};
var bannerErrorBoundaryProps = {
  buttonText: 'Reload Item',
  iconType: 'failure',
  reloadIcon: true,
  reloadButtonPosition: 'right',
  sectionWidth: '188px',
  sectionMargin: '0px'
};
var overlaysBackgroundsErrorBoundaryProps = {
  buttonText: 'Reload Item',
  iconType: 'failure',
  reloadIcon: true,
  reloadButtonPosition: 'center',
  sectionWidth: '100%'
};
var programAreaErrorBoundaryPops = {
  header: 'Something went wrong!',
  description: 'There was a problem loading Main Program. Please try to reload this feature and if the problem persists, reach out to client support.',
  buttonText: 'Reload',
  iconType: 'failure',
  reloadIcon: false,
  reloadButtonPosition: 'left',
  sectionTextAlign: 'left',
  sectionWidth: '498px',
  sectionMargin: '16px 190px 170px 320px'
};
var getSourceErrorBoundaryProp = function getSourceErrorBoundaryProp() {
  return {
    sectionWidth: '200px',
    buttonText: 'Reload',
    iconType: 'failure',
    reloadIcon: false,
    reloadButtonPosition: 'center',
    sectionHeight: '136px',
    sectionMargin: '0 16px 16px 0'
  };
};
var getElementErrorBoundaryProps = exports.getElementErrorBoundaryProps = function getElementErrorBoundaryProps(componentType) {
  var errorBoundaryProps = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.SCENE, sceneErrorBoundaryProps), _constants.SOURCE, getSourceErrorBoundaryProp()), _constants.BANNER, bannerErrorBoundaryProps), _constants.OVERLAY_BACKGROUND, overlaysBackgroundsErrorBoundaryProps), _constants.PROGRAM_AREA, programAreaErrorBoundaryPops);
  return errorBoundaryProps[componentType];
};